import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';
import { exportCampaignTrackingLinks, fetchTrackingLinks } from '@/services/ab-testing';
import { ABComparisonView } from '@/routes/console/_authenticated/_layout/campaigns/$publicId/_layout/ab-testing/_layout/-features/ab-comparison-view';
import { ExportCSVButton } from '@/routes/console/_authenticated/_layout/campaigns/$publicId/_layout/-features/export-csv-button';
import { useAuthenticationState } from '@/hooks/use-authentication';
export const Route = createFileRoute('/console/_authenticated/_layout/campaigns/$publicId/_layout/ab-testing/_layout/destinations/')({
    component: DestinationsABPage,
});
function DestinationsABPage() {
    const { publicId } = Route.useParams();
    const { workspace } = useAuthenticationState();
    const { from, to, excludeDevices, excludeBrowsers } = Route.useSearch();
    const [fromDate, toDate] = React.useMemo(() => [new Date(from), new Date(to)], [from, to]);
    const q = useQuery({
        queryKey: ['ab', 'destinations', publicId, fromDate, toDate, excludeDevices, excludeBrowsers],
        queryFn: () => fetchTrackingLinks({
            publicId,
            from: fromDate,
            to: toDate,
            excludeDevices,
            excludeBrowsers,
        }),
    });
    if (!workspace)
        return null;
    return (<ABComparisonView title="Destinations" description="Compare destination links across the campaign." heroLabel="Destination scans" comparison={q.data} loading={q.isPending} error={q.isError} itemName="Destination" actions={<ExportCSVButton filename={`adora-ab-destination-${publicId}-${format(new Date(), 'yyyy-MM-dd')}.csv`} workspace={workspace} request={() => exportCampaignTrackingLinks({
                publicId,
                from: fromDate,
                to: toDate,
                excludeDevices,
                excludeBrowsers,
                fileFormat: 'csv',
            })}/>}/>);
}
